var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"app":""}},[_c('v-row',{staticClass:"mx-0 my-2",attrs:{"justify":"start"}},[_c('v-col',{attrs:{"cols":"12","md":"9"}},[_c('v-row',_vm._l((_vm.events),function(event){return _c('v-col',{key:event._id,attrs:{"cols":"12","sm":"6","md":"4"}},[_c('EventCard',{attrs:{"event":event}})],1)}),1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }